import { Component } from 'react';
import ImageSliderArrow from './image-slider-arrow';
import ImageSliderItem from './image-slider-item';

import './image-slider.css';

/**
* Mostly this works by creating a duplicated element of the full width image slider in front of the max width image
* slider which handles the scroll bar
* Essentially when the scroll bar is moved, it moves the clone in front.
* Clone in front is to handle hovering of elements showing shadow correctly, but also for mouse dragging scroll.
*
* Props:
* data - an array / array of arrays - containing the inner data of the element.
* title - the title of the element which shows above the element for now, this could change at a later date depending
*         if the component itself needs to adapt.
* rows - a number of rows that wish to be shown.
*/

class ImageSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      cloneLeft: 0,
      leftArrow: false,
      rightArrow: true,
    };
  }

  componentDidMount = () => {
    this.renderItems();
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.data !== this.props.data) {
      this.renderItems();
    }
  }

  toggleScrollArrows = () => {
    // Check if the scroll bar is at the start or end of the scroll track
    // Removes left or right arrow depending where the scroll bar is on the track
    // If scroll bar is at the start, remove left arrow as the scroll bar can not go any further left
    // If scroll bar is at the end, remove right arrow as the scroll bar can not go any further right
    const { scrollLeft } = this.slider;
    const { scrollWidth } = this.slider;
    const { clientWidth } = this.slider;
    const maxScrollLeft = scrollWidth - clientWidth;

    this.setState({
      leftArrow: true,
      rightArrow: true
    }, () => {
      if (maxScrollLeft === 0) {
        this.setState({
          rightArrow: false,
        });
      }

      if (scrollLeft === 0) {
        this.setState({
          leftArrow: false
        });
      }

      if (scrollLeft === maxScrollLeft) {
        this.setState({
          rightArrow: false,
        });
      }
    });
  }

  handleScroll = () => {
    this.toggleScrollArrows();

    const { scrollLeft } = this.slider;
    const { onClick } = this.props;
    if (window.innerWidth < 768 && window.innerHeight < 1097) {
      this.sliderClone.scrollLeft = scrollLeft;

      if (onClick) {
        onClick();
      }
    } else {
      this.setState({
        cloneLeft: -scrollLeft
      }, () => {
        if (onClick) {
          onClick();
        }
      });
    }
  }

  handleManualScroll = () => {
    if (window.innerWidth < 768 && window.innerHeight < 1097) {
      this.toggleScrollArrows();
      const { scrollLeft } = this.sliderClone;
      this.slider.scrollLeft = scrollLeft;
      const { onClick } = this.props;
      if (onClick) {
        onClick();
      }
    }
  }

  handleArrowScroll = (direction) => {
    // 342 chosen as the max image size according to specifications is 334px + 4 pixels each side for margin = 334px + 8px = 342.
    let imageWidth = 342;
    if (window.innerWidth < 480 && window.innerHeight < 1097) {
      imageWidth = 208;
    } else if (window.innerWidth < 768 && window.innerHeight < 1097) {
      imageWidth = 288;
    }
    if (direction === 'right') {
      this.slider.scrollLeft += imageWidth;
    } else if (direction === 'left') {
      this.slider.scrollLeft -= imageWidth;
    }
  }

  renderItems = () => {
    // Product get passed through as an object of objects
    let data;
    if (typeof this.props.data === 'object' && this.props.data !== null) {
      data = Object.keys(this.props.data).map(key => this.props.data[key]);
    } else {
      data = this.props;
    }

    // Used for handling multiple rows, essentially we split the data into differen array stacks based on the modulo value of the index.
    // We then chunk the array at the start to ensure the ordering is correct.
    // 1 2 3 4 5 6 7 8
    // becomes
    // 1 3 5 7
    // 2 4 6 8
    // Otherwise we just use the data as is

    const rowArray = [];

    if (this.props.rows > 1 && data.length > 6) {
      for (let i = 0; i < this.props.rows; i += 1) {
        rowArray.unshift(data.filter(item => data.indexOf(item) % (this.props.rows - i)));

        if (i === this.props.rows - 1) {
          this.setState({
            data: rowArray
          }, () => {
            this.toggleScrollArrows();
          });
        }
      }
    } else {
      this.setState({
        data
      }, () => {
        this.toggleScrollArrows();
      });
    }
  }

  render() {
    return (
      <div className="slider-outer-container">
        {this.props.title && (
          <div id={this.props.title} name={this.props.title} className="slider-title-wrapper user-inner-container">
            <h2>{this.props.title}</h2>
          </div>
        )}

        <div className="slider-wrapper user-inner-container">
          <div
            className="slider-clone"
            id='slider-clone'
            ref={(el) => { this.sliderClone = el; }}
            onScroll={this.handleManualScroll}
            style={{ left: this.state.cloneLeft }}
          >
            {(this.props.rows > 1 && this.props.data.length > 6) ? (
              this.state.data.map((row, key) => (
                <div key={key}>
                  {row.map((item, innerKey) => (
                    <ImageSliderItem key={innerKey} inner={item} />
                  ))}
                </div>
              ))
            ) : (
              this.state.data.map((item, key) => (
                <ImageSliderItem key={key} inner={item} />
              ))
            )}
          </div>
          <div
            ref={(el) => { this.slider = el; }}
            className="slider-container"
            onScroll={e => this.handleScroll(e)}
            id='slider-container'
          >
            {(this.props.rows > 1 && this.props.data.length > 6) ? (
              this.state.data.map((row, key) => (
                <div key={key}>
                  {row.map((item, innerKey) => (
                    <ImageSliderItem key={innerKey} inner={item} />
                  ))}
                </div>
              ))
            ) : (
              this.state.data.map((item, key) => (
                <ImageSliderItem key={key} inner={item} />
              ))
            )}
          </div>
        </div>
        {this.state.leftArrow &&
          <ImageSliderArrow direction='left' handleArrowScroll={this.handleArrowScroll} />
        }
        {this.state.rightArrow &&
          <ImageSliderArrow direction='right' handleArrowScroll={this.handleArrowScroll} />
        }
      </div>
    );
  }
}

export default ImageSlider;
